<template>
  <div class="">
    <section class="section section-md">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-12">
            <div class="pr-md-5">
              <icon
                name="ni ni-world"
                class="mb-5"
                size="lg"
                type="success"
                shadow
                rounded
              ></icon>
              <h3>其他醫學產品</h3>
              <span>在此困難時期, 提供隨時可用的高質量口罩<br />醫用外科口罩 - ASTM-F2100 3 級<br />防護服 – BH800</span>
            </div>
          </div>
          <div class="col-md-6">
            <img src="img/main/p-mask.jpg" class="img-fluid" />
          </div>
          <div class="col-md-6">
            <img src="img/main/p-cloth.png" class="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {};
</script>